import React, { useState } from 'react';
import cn from 'classnames';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';

import styles from './FilterCollapse.module.scss';

type FilterCollapseProps = {
  title: JSX.Element;
  className?: string;
  bodyClassName?: string;
  open?: boolean;
};

const FilterCollapse: React.FC<FilterCollapseProps> = ({
  className,
  bodyClassName,
  title,
  open = false,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(open);
  const toggleCollapse = () => setIsExpanded(!isExpanded);
  return (
    <div
      className={cn(
        styles.collapseWrapper,
        { [styles.isExpanded]: isExpanded },
        className
      )}
    >
      <div
        className={styles.collapseHeader}
        onKeyPress={toggleCollapse}
        onClick={toggleCollapse}
        role="button"
        tabIndex={0}
      >
        <div className={styles.collapseTitle}>{title}</div>
        <button className={styles.collapseToggle} type="button">
          <MillionsIcon name="chevronDown" className={styles.icon} />
        </button>
      </div>
      <div className={cn(styles.collapseBody, bodyClassName)}>{children}</div>
    </div>
  );
};

export default FilterCollapse;
